import reducer from "./reducer";
export { default as CurrentProcesses } from "./components/index";
export { default as currentProcessesReducerName } from "./constants";
export default reducer;
